module.exports = __webpack_public_path__ + "img/seleteheader.82a6a184.svg";